<template>
  <div class="grid-control__container table-modifiers clearfix">
    <p class="section__title--text">Open Balance Summary (Aging)</p>
  </div>
  <Grid
    class="balance-summary-grid"
    :data-items="summary"
    :columns="columns"
    :scrollable="'none'"
    :loader="summaryLoading"
  >
    <template v-slot:paymentCell>
      <td class="k-table-td">
        <DollarIcon />
      </td>
    </template>
  </Grid>
</template>

<script setup lang="ts">
import type { Aging } from "@/Domain/Aging";
import { Grid, type GridColumnProps } from "@progress/kendo-vue-grid";
import { onBeforeMount, ref } from "vue";
import { api } from "@/api";
import { useMainStore } from "@/stores/useMainStore";
import DollarIcon from "@/icons/DollarIcon.vue";
import { handleResponsePromiseAsync } from "@/shared/helpers/apiHelper";

const main = useMainStore();

const summary = ref<Aging[]>([]);
const summaryLoading = ref<boolean>(false);

const columns = ref<GridColumnProps[]>([
  {
    title: "Current to 30 days",
    field: "AGPERAMT_2",
    type: "number",
    format: "{0:c}",
  },
  {
    title: "31 - 60 days",
    field: "AGPERAMT_3",
    type: "number",
    format: "{0:c}",
  },
  {
    title: "61 - 90 days",
    field: "AGPERAMT_4",
    type: "number",
    format: "{0:c}",
  },
  {
    title: "Over 90 days",
    field: "Column1",
    type: "number",
    format: "{0:c}",
  },
  {
    title: "Balance",
    field: "CUSTBLNC",
    type: "number",
    format: "{0:c}",
  },
  {
    width: "50px",
    cell: "paymentCell",
  },
]);

const getAgingCustomerBalanceAsync = async function () {
  if (summaryLoading.value) return;
  summaryLoading.value = true;
  await handleResponsePromiseAsync(
    api.get("GetAgingCustomerBalance", {
      companyLogin: main.companyLogin,
    }),
    (data) => {
      summary.value = data.ListItems;
      main.balance =
        summary.value.length > 0
          ? Number.parseFloat(summary.value[0].CUSTBLNC)
          : null;
      console.debug(
        `BalanceSummaryTable.vue: getAgingCustomerBalanceAsync(), result:`,
        data
      );
    },
    "BalanceSummaryTable.vue",
    "getAgingCustomerBalanceAsync"
  );
  summaryLoading.value = false;
};

onBeforeMount(async () => {
  await getAgingCustomerBalanceAsync();
});
</script>
